import { render, staticRenderFns } from "./KOR.vue?vue&type=template&id=0dcde678&scoped=true&"
import script from "./KOR.vue?vue&type=script&lang=js&"
export * from "./KOR.vue?vue&type=script&lang=js&"
import style0 from "./KOR.vue?vue&type=style&index=0&id=0dcde678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcde678",
  null
  
)

export default component.exports